import { NotificationProtocol } from '@/lib/types';

/** Stable list key: stored id, or creation time for live socket items. */
export function notificationKey(message: NotificationProtocol): string {
  return message.id ?? `${message.head.type}:${message.tail.created ?? ''}`;
}
